module.exports = __webpack_public_path__ + "images/448c6eed44b4cc896da431d5f7e4de85-c6.jpg";